<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div>
                  <!-- <p><br /></p>
                  <p><br /></p> -->
                  <div v-for="item in images" :key="item.id" class="title">
                    <!-- {{item  }} -->
                    <img :src="item.path" alt="" />
                  </div>
                  <div v-for="(item, index) in contents" :key="index">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      contents: [],
      images: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getZzjg();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getZzjg() {
      console.log(888);
      // if (this.index != null) {
      axios
        .get("/jtg/home/content/" + 45)
        .then((result) => {
          let res = JSON.parse(JSON.stringify(result.data));
          this.contents = res.data.contents;
          this.images = res.data.images;
          // this.last = this.form.lastArticle;
          // this.next = this.form.nextArticle;
        });
    },
  },
  // },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .title {
          margin-bottom: 20px;
        }
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>